<app-modal
  #updateModal
  [title]="title"
  [footer]="footerTemplate"
  [showClose]="false">
  <div *ngIf="icon" class="text-center mb-3">
    <i [class]="icon"></i>
  </div>
  <p *ngFor="let message of messages">{{ message }}</p>
</app-modal>

<ng-template #footerTemplate>
  <button class="btn btn-primary" (click)="refresh()">{{ buttonText }}</button>
</ng-template>
